import { loadStripe } from '@stripe/stripe-js';

export const stripePromise = loadStripe('pk_test_51KSI8EL9yg3OMPIrHPSeJarjCDtNV0IAkebVZspq5wiesdnpqNvHwiAzk65uU1Vp2LpxdwOdewVoJuw2pOOnl0nF00O2dZwuti');
